export default class List {
  constructor(appId, io, name, state) {
    this._io = io;
    this._stateName = name;
    this._state = state;
    this._itemUpdatedCallbacks = [];
    this._itemAddedCallbacks = [];
    this._syncCallbacks = [];
    this._io.on(`item-updated-${appId}-${name}`, state => {
      this._state.rev = state.rev;
      this._state.data[state.data.index] = state.data.value;
      this._itemUpdatedCallbacks.forEach(cb => cb(state.data));
    });
    this._io.on(`item-added-${appId}-${name}`, state => {
      this._state.rev = state.rev;
      this._state.data[state.data.index] = state.data.value;
      this._itemAddedCallbacks.forEach(cb => cb(state.data));
    });

    this._io.on("reconnect", () => {
      this._io.emit("get-state", this._stateName, response => {
        if (!response.error) {
          if (response.rev !== this._state.rev) {
            this._state = response;
            this._syncCallbacks.forEach(cb => cb(response.data));
          }
        }
      });
    });
  }

  onItemAdded(cb) {
    if (typeof cb !== "function")
      throw Error("Expected a function but got an invalid parameter type");
    this._itemAddedCallbacks.push(cb);
  }

  onItemUpdated(cb) {
    if (typeof cb !== "function")
      throw Error("Expected a function but got an invalid parameter type");
    this._itemUpdatedCallbacks.push(cb);
  }

  onSync(cb) {
    if (typeof cb !== "function")
      throw Error("Expected a function but got an invalid parameter type");
    this._syncCallbacks.push(cb);
  }

  update(index, value) {
    if (value === null || value === undefined) throw Error("State is invalid");
    else {
      this._io.emit("list-update", {
        name: this._stateName,
        rev: this._state.rev,
        state: { value, index }
      });
    }
  }

  push(value) {
    if (value === null || value === undefined) throw Error("State is invalid");
    else {
      this._io.emit("list-push", {
        name: this._stateName,
        rev: this._state.rev,
        state: value
      });
    }
  }

  getAll() {
    return this._state.data;
  }

  getByIndex(index) {
    return this._state.data[index];
  }
}
